module.exports = __webpack_public_path__ + "img/Liift4.3dbb252a.jpeg";